import { Component, ElementRef, Input } from '@angular/core';
import { TotemWidget } from '../totem-widget';
import { PgAvailabilitySelectData } from 'pg-lib/models/booking.model';
import { TimetableDataList } from 'pg-lib/models/timetable.model';
import { CustomerCareService } from 'pg-lib/services/customer-care.service';
import { LocalizationService } from 'pg-lib/services/localization.service';

@Component({
    selector: 'app-totem-widget-customer-care',
    templateUrl: './totem-widget-customer-care.component.html',
    styleUrls: ['./totem-widget-customer-care.component.scss'],
    standalone: false
})
export class TotemWidgetCustomerCareComponent extends TotemWidget {
    constructor(public elementRef:ElementRef, private customerCareService:CustomerCareService, private localizationService:LocalizationService) {
        super(elementRef);
    }
    
    size:'md' = 'md'

    @Input() realmId:string;
    @Input() customerCareChannel:string;

    isLoading = false;

    filteredAvailabilityData:Array<PgAvailabilitySelectData> = []

    ngOnInit() {
        super.ngOnInit()
        
        this.isLoading = true;

        this.customerCareService.getAvailability(this.realmId, this.customerCareChannel).subscribe((data) => {

            console.log('TODO: remove mock data')
            data = [{
                id: '222',
                capacity: 20,
                availability: new TimetableDataList([
                    {
                        hours: [{
                            begin: '00:00',
                            end: '01:00',
                            days: [true,true,true,true,true,true,true]
                        }],
                        periods: [{
                            begin: { month: 1, day: 1 },
                            end: { month: 12, day: 31 }
                        }] 
                    }
                ])
            }]

            this.isLoading = false;

            for(let _availability of data) {
                if(_availability.languages == null || _availability.languages.indexOf(this.localizationService.currentLanguage) != -1) {
                    this.filteredAvailabilityData.push(_availability)
                }
            }
        }, () => {
            this.isLoading = false;
        })
    }
}
